<template>
    <section id="premii" class="prizes">
        <div class="container prizes-wrapper">
            <h1 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="50" class="section__title">Premiile Pufina</h1>
            <h6 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100" class="teaser__text">
                Cumpără orice produs Pufina și te poți bucura de premii
            </h6>
            <div class="prizes__row">
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200" class="prizes__card">
                    <div class="scratch_container">
                        <div class="scratch_viewport">
                            <!-- result picture -->
                            <canvas id="js-scratch-canvas"></canvas>
                        </div>
                    </div>
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" data-aos-delay="300" class="prizes__card">
                    <div class="scratch_container">
                        <div class="scratch_viewport">
                            <!-- result picture -->
                            <canvas id="js-scratch-canvas-2" width="450" height="250"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="prizes__shapes">
            <img data-aos="zoom-put-up" data-aos-duration="2000" data-aos-delay="400" class="prizes__shapes--1" src="images/bg/rounded-line.png" alt="">
            <div data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500" class="circle__pink prizes__shapes--2"></div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>